import { cdnApiClient } from './cdnApiClient';
import { cdnApiPath } from './cdnApiPaths';

export const createOrganization = (requestData) => cdnApiClient.request(
  cdnApiPath('organizations'),
  { method: 'POST', body: requestData },
);

export const updateOrganization = (id, requestData) => cdnApiClient.request(
  cdnApiPath(`organizations/${id}`),
  { method: 'PUT', body: requestData },
);

export const getOrganizations = () => cdnApiClient.request(cdnApiPath('organizations'));

export const getUserOrganizations = () => cdnApiClient.request(cdnApiPath('user-organizations'));

export const getOrganizationUserOrganizations = (requestData) => {
  const { organizationId } = requestData;
  return cdnApiClient.request(cdnApiPath(`organizations/${organizationId}/user-organizations`));
};

export const updateUserOrganization = (requestData) => {
  const { organizationId, userOrganizationId, ...rest } = requestData;
  return cdnApiClient.request(
    cdnApiPath(`organizations/${organizationId}/user-organizations/${userOrganizationId}`),
    { method: 'PUT', body: { ...rest } },
  );
};

export const deleteUserOrganization = (requestData) => {
  const { organizationId, userOrganizationId } = requestData;
  return cdnApiClient.request(
    cdnApiPath(`organizations/${organizationId}/user-organizations/${userOrganizationId}`),
    { method: 'DELETE' },
  );
};

export const joinOrganization = (requestData) => {
  const { id, ...rest } = requestData;
  return cdnApiClient.request(
    cdnApiPath(`organizations/${id}/user-organizations`),
    { method: 'POST', body: { ...rest } },
  );
};

export const verifyOrganization = (organizationId) => cdnApiClient.request(
  cdnApiPath(`organizations/${organizationId}/verifications`),
  { method: 'POST', body: {} },
);
